import css from 'styled-jsx/css';

export default css`
  .RecipeRoundup__recipe {
    position: relative;
  }

  .RecipeRoundup__recipe :global(.SaveRecipeActionButton__saveRecipeToBox) {
    position: absolute;
    z-index: 99;
    right: 0.5rem;
    bottom: 1.5rem;
  }
`;
